import React, { useState, useMemo, useEffect } from "react";
import DataTable from "react-data-table-component";
import { BlurSpinner } from "../../../../../../../components/BlurSpinner";
import useFetcher from "../../../../../../../hooks/useFetcher";
import { fetchPcm } from "../../../../../../../services/reportingServices";

const Component = ({ filters, setItemsPerPage: setParentItemsPerPage }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sort, setSort] = useState({ sortBy: "date", sortDirection: "desc" });
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [paymentCondition, setPaymentCondition] = useState();

  const formatMonthYear = (dateString) => {
    const [year, month] = dateString.split("-");
    return `${month}-${year}`;
  };

  // eslint-disable-next-line no-unused-vars
  const [data, isLoading, error, setData, fetchData] = useFetcher(fetchPcm, [
    {
      endDate: filters.endDate,
      startDate: filters.startDate,
      razonSocial: filters.cliente,
      page: currentPage,
      perpage: itemsPerPage,
      orderBy: sort.sortBy,
      orderType: sort.sortDirection,
    },
  ]);

  const columns = useMemo(
    () => [
      {
        name: "Fecha",
        selector: (row) => formatMonthYear(row.date),
        id: "date",
        sortable: true,
        center: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        name: "PMC",
        selector: (row) => row.pmc,
        id: "pmc",
        sortable: false,
        center: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        name: "C. de pago",
        selector: () => paymentCondition,
        id: "condicion-de-pago",
        sortable: false,
        center: true,
        width: "100px",
        minWidth: "100px",
      },
    ],
    [paymentCondition]
  );

  useEffect(() => {
    setParentItemsPerPage(itemsPerPage);
  }, [itemsPerPage]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchData();
    }, 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [fetchData]);

  useEffect(() => {
    if (!!data && !!data.pmcList) {
      setRows(data.pmcList.rows);
      setTotal(data.pmcList.count);
      setPaymentCondition(data.condicionDePago);
    }
  }, [data]);

  return (
    <BlurSpinner isLoading={(!rows, isLoading)}>
      <DataTable
        className="custom-table pmc-table"
        paginationComponentOptions={{ rowsPerPageText: "Mostrar", rangeSeparatorText: "de", selectAllRowsItemText: "Todos" }}
        noDataComponent={
          <div className="p-3">
            <b>No se encontraron resultados</b>
          </div>
        }
        striped
        pagination
        sortServer
        paginationServer
        data={rows}
        paginationTotalRows={total}
        paginationDefaultPage={1}
        onChangeRowsPerPage={setItemsPerPage}
        paginationPerPage={itemsPerPage}
        onSort={(a, b) => setSort({ sortBy: a.id, sortDirection: b })}
        onChangePage={setCurrentPage}
        columns={columns}
      />
    </BlurSpinner>
  );
};

export default Component;
